import { createAction, handleActions } from 'redux-actions';

import { fromJS } from 'immutable';
import { pender } from 'redux-pender';

//------------------------------------------------------
//api
//------------------------------------------------------
import * as api from 'store/actions/AdminApi';

//------------------------------------------------------
//action type
//------------------------------------------------------
const GET_ADMIN_WORKBOOK_LIST = 'GET_ADMIN_WORKBOOK_LIST';
const GET_ADMIN_REGISTER_LIST = 'GET_ADMIN_REGISTER_LIST';
const GET_ADMIN_FILE_LIST = 'GET_ADMIN_FILE_LIST';
const POST_ADMIN_FILE_CHANGE = 'POST_ADMIN_FILE_CHANGE';
const POST_ADMIN_CHANGE_TUTOR_MEMO = 'POST_ADMIN_CHANGE_TUTOR_MEMO';

//------------------------------------------------------
// action creators
//------------------------------------------------------
export const getAdminWorkbookList = createAction(GET_ADMIN_WORKBOOK_LIST, api.getAdminWorkbookList);
export const getAdminRegisterList = createAction(GET_ADMIN_REGISTER_LIST, api.getAdminRegisterList);
export const getAdminFileList = createAction(GET_ADMIN_FILE_LIST, api.getAdminFileList);
export const postMyReviewpostAdminFileChangeList = createAction(POST_ADMIN_FILE_CHANGE, api.postAdminFileChange);
export const postAdminChangeTutorMemo = createAction(POST_ADMIN_CHANGE_TUTOR_MEMO, api.postAdminChangeTutorMemo);

//------------------------------------------------------
// initial state
//------------------------------------------------------
const initialState = fromJS({
    adminWorkbookList:[],
    adminRegisterList:[],
    adminFileList:[],
});

//------------------------------------------------------
// reducer
//------------------------------------------------------
export default handleActions({
    ...pender({
        type : GET_ADMIN_WORKBOOK_LIST,
        onSuccess : (state, action) => {
            const {data} = action.payload;

            if (!data.result || !data.data) return state;

            return state.set('adminWorkbookList', data.data);
        },
    }),
    ...pender({
        type : GET_ADMIN_REGISTER_LIST,
        onSuccess : (state, action) => {
            const {data} = action.payload;

            if (!data.result || !data.data) return state;

            return state.set('adminRegisterList', data.data);
        },
    }),
    ...pender({
        type : GET_ADMIN_FILE_LIST,
        onSuccess : (state, action) => {
            const {data} = action.payload;

            if (!data.result || !data.data) return state;

            return state.set('adminFileList', data.data);
        },
    }),
}, initialState)
